// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3pApF","Label":"BuildControl_Label__1nLPd","Less":"BuildControl_Less__2ME3v","More":"BuildControl_More__2Czam"};